<template>
  <!-- FT-191 REQ-09: в другой вкладке сменился сотрудник — эта вкладка закрыта и в хранилище не
       пишет. «Обновить» доступна, когда новый сотрудник загрузился (switch_ready). -->
  <div class="tab-closed" data-test="tab-closed" data-device-overlay role="dialog" aria-modal="true" :aria-label="$t('device_lock.tab_closed')">
    <v-card max-width="420" flat class="text-center pa-4">
      <v-card-title class="justify-center">{{ $t("device_lock.tab_closed") }}</v-card-title>
      <v-card-actions class="justify-center">
        <v-btn ref="reload" color="primary" data-test="tab-closed-reload" :disabled="!ready" @click="reload">
          {{ $t("device_lock.reload") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { isolateOverlay } from "@/utils/deviceLock";

export default {
  name: "TabClosedOverlay",
  computed: {
    ready() {
      return this.$store.getters["deviceLock/switchReady"];
    },
  },
  watch: {
    // Enter после смены сотрудника должен перезагрузить вкладку, а не нажать кнопку старой страницы.
    ready(value) {
      if (value) this.$nextTick(this.focusReload);
    },
  },
  mounted() {
    this.restorePage = isolateOverlay(this.$el);
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    if (this.ready) this.$nextTick(this.focusReload);
  },
  beforeDestroy() {
    if (this.restorePage) this.restorePage();
  },
  methods: {
    focusReload() {
      if (this.$refs.reload && this.$refs.reload.$el) this.$refs.reload.$el.focus();
    },
    reload() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.tab-closed {
  position: fixed;
  inset: 0;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--v-background-base, #fff);
  padding: 16px;
}
</style>
